import { createAction, handleActions } from 'redux-actions'

export const preparePaymentSuccess = createAction('PREPARE_PAYMENT_SUCCESS')
export const updateTotalPayment = createAction('UPDATE_TOTAL_AMOUNT')
export const clearPayment = createAction('CLEAR_PAYMENT')
export const setPaymentLocation = createAction('SET_PAYMENT_LOCATION')

export const paymentReducer = handleActions(
  {
    PREPARE_PAYMENT_SUCCESS: (state, action) => {
      return {
        ...state,
        ...action.payload
      }
    },

    UPDATE_TOTAL_AMOUNT: (state, action) => {
      return { ...state, amount: action.payload.amount }
    },

    CLEAR_PAYMENT: (state, action) => {
      return { ...state, amount: 0 }
    },

    SET_PAYMENT_LOCATION: (state, action) => {
      return {
        ...state,
        locationId: action.payload
      }
    }
  },
  {
    queryString: '',
    scriptTag: '',
    amount: 0,
    locationId: null
  }
)



// WEBPACK FOOTER //
// ./src/redux/modules/paymentModule.js